import Table from '@/components/table/components/Table.tsx';
import tourClientsApi from '@/features/dashboard/tours/api/tourClientsApi.ts';
import {
  tourClientsRoute,
  tourRoute,
} from '@/features/dashboard/tours/routes/tourRoute.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { tourClientsApiQueryKeys } from '@/features/dashboard/tours/api/tourClientsApi.queryKeys.ts';

const TourClientsTable = () => {
  const { tourId } = tourRoute.useParams();
  const search = tourClientsRoute.useSearch();

  return (
    <Table
      listSearch={search}
      queryKey={tourClientsApiQueryKeys.tourClients(tourId)}
      fetchData={(pr, fc: FilterCriteriaDto) =>
        tourClientsApi.getClients(tourId, pr, fc)
      }
      fetchTableDef={() => tourClientsApi.getTableDef(tourId)}
      // Enables row selection + the floating bar with "export selected".
      // Add context actions here once an endpoint exists, e.g.:
      // bulkActions={[createDeleteSelectedAction({ onDelete: (rows) => ... })]}
      bulkActions={[]}
      title="Zapisujący"
    />
  );
};

export default TourClientsTable;
